/* Keep OCU's controls and price nodes intact; change only summary label text. */
(() => {
  if (window.upliefCartPresentationLoaded) return;
  window.upliefCartPresentationLoaded = true;
  const observed = new WeakSet();
  const replaceLabel = (label, text) => {
    if (!label || label.textContent.trim() === text) return;
    const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim()) {
        node.textContent = text;
        return;
      }
    }
  };
  const update = drawer => {
    drawer.querySelectorAll('.ocu-discount-info').forEach(row => {
      replaceLabel(row.firstElementChild, 'You Save');
    });
    drawer.querySelectorAll('.ocu-estimated-info').forEach(row => {
      replaceLabel(row.querySelector(':scope > .ocu-editable-cart-text'), 'Total');
    });
  };
  const attach = () => {
    const drawers = document.querySelectorAll('.ocu-cart-drawer');
    drawers.forEach(drawer => {
      update(drawer);
      if (observed.has(drawer)) return;
      observed.add(drawer);
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; update(drawer); });
      }).observe(drawer, {childList:true, subtree:true, characterData:true});
    });
    return drawers.length > 0;
  };
  const start = () => {
    attach();
  };
  ['ocu:cart:loaded', 'ocu:cart:opened', 'ocu:cart:updated'].forEach(event => {
    window.addEventListener(event, attach);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
